// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#debugWindow[data-v-3d530ab0] {\n    width: 500px;\n    height: 500px;\n    position: absolute;\n    z-index: 500;\n    background: black;\n}\n#debugWindowHeader[data-v-3d530ab0] {\n    background-color: darkorange;\n    text-align: center;\n}\n#debugTesture[data-v-3d530ab0] {\n    /*width: 500px;*/\n    /*height: 500px;*/\n    /*display: none;*/\n}\n\n", ""]);
// Exports
module.exports = exports;
